import { GET_BLOCK } from "../actions/types";

const initialState=[]
export default function blocks(state = initialState, action) {
    switch (action.type) {
      case GET_BLOCK:
        return action.payload;
      default:
        return state;
    }
  }